export function getWithdrawalRequest() {
    return axios({
        url: `/api/withdrawal-requests`,
        method: 'get',
    });
}


export function getReissueSettings(productId,moduleId) {
    return axios({
        url: `/api/reissue-settings/${productId}/${moduleId}`,
        method: 'get',
    });
}


/**
 *
 * @param data
 * @returns {*}
 */
export function createWithdrawalRequest(data) {
    return axios({
        url: `/api/withdrawal-requests`,
        method: 'post',
        data: data,
    });
}

export function createReissue(orderId, data) {
    let form_data = new FormData();
    form_data.append('order_id', orderId);
    form_data.append('status', 'pending');
    for (let key in data) {
        console.log('data[key]', data[key])
        if (['file', 'fileTech'].includes(key) && Array.isArray(data[key])) {
            data[key].forEach(file => {
                form_data.append(`data[${key}][]`, file, file.name) // check this out for more info: https://developer.mozilla.org/en-US/docs/Web/API/FormData/append#example
            })
        } else {
            form_data.append(`data[${key}]`, data[key]);
        }

    }

    return axios.post(`/api/withdrawal-requests`, form_data,{
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}



